module.exports = __webpack_public_path__ + "fonts/FreightNeoProBlack-Regular.9216b710.otf";